(function () {
    'use strict';

    angular
        .module('jotApp')
        .directive('maintenanceMessage', maintenanceMessage);

    function maintenanceMessage() {
        var directive = {
            restrict: 'E',
            template: '<a><span class="fa fa-warning"></span></a>',
            controller: MaintenanceMessageController
        };
        return directive;
    }

    MaintenanceMessageController.$inject = [];

    function MaintenanceMessageController() {
    }
})();
